module.exports = __webpack_public_path__ + "static/img/4.423152a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/4.jpg
// module id = PiDM
// module chunks = 5